import { render, staticRenderFns } from "./Getraenke.vue?vue&type=template&id=2d8a0c7e&scoped=true"
import script from "./Getraenke.vue?vue&type=script&lang=js"
export * from "./Getraenke.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a0c7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8a0c7e')) {
      api.createRecord('2d8a0c7e', component.options)
    } else {
      api.reload('2d8a0c7e', component.options)
    }
    module.hot.accept("./Getraenke.vue?vue&type=template&id=2d8a0c7e&scoped=true", function () {
      api.rerender('2d8a0c7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Getraenke.vue"
export default component.exports